module.exports = __webpack_public_path__ + "img/30.7434e625.png";